// extracted by mini-css-extract-plugin
export default {"orgControlledBackground":"UKW27AlTK8lGpK7uoPiA"};